import React, { forwardRef } from 'react'
import { TouchableOpacity } from 'react-native'

import { colors } from '@zet/design-system'
import { Stack, XStack } from '@zet/design-system/layout'
import { B5 } from '@zet/design-system/typography'
import { useUnsafeVariable } from 'nativewind'

import BankIcon from '../../assets/icons/BankIcon'
import CurrencyIcon from '../../assets/icons/CurrencyIcon'
import { M14 } from '../typography'

interface FieldOption {
  optionValue: string
  optionId: any
  icon?: keyof typeof icons
}

interface Props {
  label?: string
  onChange: (value: any) => void
  onBlur: () => void
  isRequired?: boolean
  fieldOptions: FieldOption[]
  value: any
  errorMessage?: string
}

const icons = {
  BankIcon,
  CurrencyIcon,
}

type IconName = keyof typeof icons

const IconRenderer: React.FC<{
  iconName: IconName
  color: string
  size: number
}> = ({ iconName, color, size }) => {
  const IconComponent = icons[iconName]
  if (!IconComponent) {
    return <></>
  }
  return <IconComponent color={color} size={size} />
}

export const Toggle: React.FC<Props> = forwardRef(
  (
    { label, onChange, onBlur, value, errorMessage, isRequired, fieldOptions },
    ref,
  ) => {
    const [colorPrimary100] = useUnsafeVariable('--color-primary-100')
    const [colorPrimary150] = useUnsafeVariable('--color-primary-150')
    return (
      <Stack>
        <XStack>
          {!!label && <M14 className="text-grays-80 my-2">{label}</M14>}
        </XStack>
        <XStack>
          {fieldOptions?.map((item) => (
            <TouchableOpacity
              onPress={() => {
                onChange(item.optionId)
                onBlur()
              }}
              key={item?.optionId}
            >
              <XStack
                style={{
                  borderColor:
                    value !== item?.optionId ? '#F6F7F8' : colorPrimary150,
                }}
                className={`mr-3 items-center justify-between rounded-3xl border pl-[14px] pr-3 py-2 bg-${value !== item?.optionId ? '[#fff]' : 'primary-10'} border-${value !== item?.optionId ? 'grays-40' : 'primary-150'}`}
              >
                {item.icon && (
                  <IconRenderer
                    iconName={item.icon}
                    color={
                      value !== item?.optionId
                        ? colors.grays[70]
                        : colorPrimary150
                    }
                    size={20}
                  />
                )}
                <M14
                  style={{
                    color:
                      value === item.optionId
                        ? colorPrimary150
                        : colors.grays[80],
                  }}
                  className={`${
                    value !== item.optionId
                      ? 'font-[Graphie-Regular]'
                      : 'font-[Graphie-SemiBold]'
                  } text-grays-80 ml-2`}
                >
                  {item.optionValue}
                </M14>
              </XStack>
            </TouchableOpacity>
          ))}
        </XStack>
        {!!errorMessage && <B5 className="text-error-100">{errorMessage}</B5>}
      </Stack>
    )
  },
)
